import { toast } from "react-hot-toast"

import { setLoading, setUser } from "../../redux/slices/profileSlice"
import { apiConnector } from "../apiconnector"
import { profileEndpoints } from "../apis"
import { logout } from "./authAPI"

const { GET_USER_DETAILS_API, GET_ALL_USERS } = profileEndpoints

export function getUserDetails(studentId,token) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...")
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("GET", GET_USER_DETAILS_API,
      { studentId },
       {
        Authorization: `Bearer ${token}`,
      })
      console.log("GET_USER_DETAILS API RESPONSE............", response)

      if (!response.data.success) {
        throw new Error(response.data.message)
      }
      const userImage = response.data.data.image
        ? response.data.data.image
        : `https://api.dicebear.com/5.x/initials/svg?seed=${response.data.data.firstName} ${response.data.data.lastName}`
      dispatch(setUser({ ...response.data.data, image: userImage }))
    } catch (error) {
     
      console.log("GET_USER_DETAILS API ERROR............", error)
      toast.error("Could Not Get User Details")
    }
    toast.dismiss(toastId)
    dispatch(setLoading(false))
  }
}

export const fetchAllStudents = async (token) => {
  let result = []
  try {
    const response = await apiConnector("GET", GET_ALL_USERS,null,{
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    })
    console.log("GET_ALL_CATEGORY_API API RESPONSE............", response)
    result = response
    if (!response?.data?.success) {
      throw new Error("Could Not Fetch Students")
    }
    result = response?.data?.data
  } catch (error) {
    console.log("GET_ALL_USERS API ERROR............", error)
    toast.error(error.message)
  }
  return result
}


